var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'Index' }}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/complete-logo.png"),"alt":"aaaaaa"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }